import { defineMessages } from 'react-intl';

export const financialDocumentRowMessages = defineMessages({
    rows: {
        id: 'rows',
        defaultMessage: 'Rows',
    },
    rowsTitle: {
        id: 'rows-title',
        defaultMessage: 'Rows',
    },
    row: {
        id: 'row',
        defaultMessage: 'Row',
    },
    quantity: {
        id: 'quantity',
        defaultMessage: 'Quantity',
    },
    charge: {
        id: 'charge',
        defaultMessage: 'Charge',
    },
    tax: {
        id: 'tax',
        defaultMessage: 'Tax',
    },
    number: {
        id: 'number',
        defaultMessage: 'Number',
    },
    taxPercent: {
        id: 'tax-percent',
        defaultMessage: 'Tax percent',
    },
    createFinancialDocumentRowSuccess: {
        id: 'create-financial-document-row-success',
        defaultMessage: 'Financial document row created',
    },
    createFinancialDocumentRowSuccessDescription: {
        id: 'create-financial-document-row-success-description',
        defaultMessage: 'The financial document row has been successfully created.',
    },
    addFinancialDocumentRowSubtitle: {
        id: 'add-financial-document-row-subtitle',
        defaultMessage: 'Create a new financial document row',
    },
    deleteFinancialDocumentRow: {
        id: 'delete-financial-document-row',
        defaultMessage: 'Delete financial document row',
    },
    deleteFinancialDocumentRowSuccess: {
        id: 'delete-financial-document-row-success',
        defaultMessage: 'Financial document row deleted',
    },
    deleteFinancialDocumentRowSuccessDescription: {
        id: 'delete-financial-document-row-success-description',
        defaultMessage: 'The financial document row has been successfully deleted.',
    },
    confirmDeleteFinancialDocumentRow: {
        id: 'confirm-delete-financial-document-row',
        defaultMessage: 'Are you sure you want to delete this financial document row? This action cannot be undone.',
    },
    deleteFinancialDocumentRowSubtitle: {
        id: 'delete-financial-document-row-subtitle',
        defaultMessage: 'Permanently delete financial document row {entity}',
    },
    editFinancialDocumentRowSubtitle: {
        id: 'edit-financial-document-row-subtitle',
        defaultMessage: 'Edit financial document row {entity}',
    },
    updateFinancialDocumentRowSuccess: {
        id: 'update-financial-document-row-success',
        defaultMessage: 'Financial document row updated',
    },
    updateFinancialDocumentRowSuccessDescription: {
        id: 'update-financial-document-row-success-description',
        defaultMessage: 'Financial document row {entity} has been successfully updated.',
    },
    nonFieldErrors: {
        id: 'custom-error:non_field_errors',
        defaultMessage: 'The fields financial_document, number must make a unique set.',
    },
    invalidRowErrors: {
        id: 'custom-error:invalid_row_number',
        defaultMessage:
            'The row number cannot be greater than the next available sequential number in the financial document!',
    },
});
